import NavLinks from "./overview/NavLinks";
import StatusMobil from "./overview/StatusMobil";

export default function() {

return <section className="menu">
        <StatusMobil />
        <NavLinks />
    </section>
}